import React, { useCallback, useEffect, useState } from 'react'
import {useNavigate } from 'react-router-dom';
import StudentCodeEntry from '../../../components/Containers/StudentCodeEntry';
import { useApp } from '../../../helpers/appContext'
import Student from '../../../components/Student/Student'
import { Section, Button, Input, Label, Value, general, Print, Modal, PaddedContent } from 'daymap-library'
import { useAuth } from '../../../helpers/authContext';
import Alert, { ALERT_TYPE } from  '../../../components/Alert/Alert';
import styles from './SignInOut.module.scss';
import { useStudentPhotoUrl } from '../../../components/Containers/StudentPhoto';

const SignInOut = ({action, actionData}) => {
    const { student, setStudent } = useApp();
    const { lmsFetch } = useAuth();
    const [details, setDetails] = useState("");
    const [reason, setReason] = useState(actionData ? actionData[0] : null);
    const [signinoutComplete, setSignInOutComplete] = useState(null);
    const [printConfirmationDetails, setPrintConfirmationDetails] = useState(null);

    let headingText = "Sign Out";
    if (action == "In")
        headingText = "Sign In";


    const studentFound = student => {
        setStudent(student);
    }

    const onTextChanged = event =>{
        setDetails(event.target.value);
    }

    const onReasonChanged = event =>{
        setReason({value: event.target.value, text: event.target.options[event.target.selectedIndex].text});
    }

    const onSignInOut = async () =>{
        let data = {studentID:student.ID , action:action , swipeReason:reason.text , swipeValue:reason.value , details:details, deleteNote: false}

        const [signinoutresult] = lmsFetch(`/lms/api/checkin/signinout`, data, {returns: 'text'});

        let result = await signinoutresult();

        if(result.status == 200) {
            setPrintConfirmationDetails({ checkInLogId: result.data, action });
        }
    }

    if (!student)
        return (<div><StudentCodeEntry onStudentFound={studentFound} getCurrentLocation={true}></StudentCodeEntry></div>)

    if(signinoutComplete){
        return <SignInOutComplete headingText={headingText}></SignInOutComplete>
    }

    return (<>
        {printConfirmationDetails && <PrintConfirmation 
            onComplete={() => setSignInOutComplete(true)}
            checkInLogId={printConfirmationDetails.checkInLogId} 
            action={printConfirmationDetails.action}
            studentId={student.ID} />}
        <div className={styles.Wrapper}>
            <Section>
                <Student {...student} />                
                <div className={styles.Padded}>                   
                    {student.CurrentLocation && <Label position="Top" text="Timetable:"><Value >{student.CurrentLocation}</Value></Label>}
                <Label text="Reason:" for="ddlReason" position="Top">
                    <Input elementType="select" value={reason.value} id="ddlReason" config={{options: actionData}} onChange={onReasonChanged} fullWidth></Input>
                </Label>
                <Label text="Details:" for="txtDetails" position="Top">
                    <Input elementType="textarea" value={details} id="textDetails" onChange={onTextChanged} fullWidth></Input>
                </Label>
                </div>
                <div className={styles.Padded}>
                    <Button text={headingText} fullWidth onClick={onSignInOut}></Button>
                </div>
            </Section>
        </div>
    </>)
    
}

const SignInOutComplete = ({headingText}) => {
    const { settings } = useAuth();
    const navigate = useNavigate();
    const [ secondsTilRedirect ] = general.useCountdown({ seconds: settings.KioskRedirectDelay, onZero: () => navigate('/checkin') });

    if(!(settings.KioskRedirectDelay > 0))
    {
        navigate('/checkin');
        return "";
    }

    return <Alert type={ALERT_TYPE.Success} heading={headingText + " Complete"}>
            Returning to Check In home page in {secondsTilRedirect} seconds.
        </Alert>
}

const PrintConfirmation = ({onComplete, checkInLogId, action, studentId}) => {
    const { lmsFetch, settings } = useAuth();
    const [printBody, setPrintBody] = useState(null);
    const [promptOpen, setPromptOpen] = useState(false);
    const studentPhotoUrl = useStudentPhotoUrl(studentId);

    const print = useCallback(() => {
        const getPrintData = async () => {
            const [printResult] = lmsFetch(`/lms/api/checkin/checkinprint?checkInLogID=${checkInLogId}&action=${action}&studentID=${studentId}`, null, {returns: 'text'});
            let printData = await printResult();
            setPrintBody(printData.data);
        }

        getPrintData();
    }, [checkInLogId, action, studentId, lmsFetch])

    useEffect(() => {
        switch (settings.CheckInPrintOption) {
            case 0: // dont print
                onComplete();
                break;
            case 1: // prompt to print
                setPromptOpen(true);
                break;
            case 2:
                print();
                break;
            default:
                break;
        }
    }, [onComplete, print, settings.CheckInPrintOption]);

    if(printBody){
        let updatedPrintBody = printBody;
        if (studentPhotoUrl)
            updatedPrintBody = printBody.replace('[photo-src]', studentPhotoUrl)
        return <Print onPrint={onComplete} printStyle={`body
        {
            margin: 0px;
            padding: 0px;
            font-family: Arial;
            font-size: 9pt;
            position: absolute;
            left: 0;
            top: 0; 
        } 
        @page {
            margin: 0.3cm 0.1cm 0.1cm 0.1cm;
        
        }
        
        .Receipt {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 290px;
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
            `} 
        printBody = {updatedPrintBody}></Print>
    }

    if (promptOpen)
        return <Modal onClose={onComplete}>
            <PaddedContent>
                <p>Print a Receipt for this Sign In?</p>
                <div>
                    <Button onClick={onComplete} text="Skip Printing" secondary></Button>
                    <Button onClick={print} text="Print"></Button>
                </div>
            </PaddedContent>
        </Modal>
    
    return null;
}

export default SignInOut;